import { action, computed, observable } from 'mobx';
import Abstract from './abstract';

export class Cart extends Abstract {
  @observable selected = [];
  @observable checked = [];

  @computed get templates() {
    const res = this.selected.map(item => item.content.template);
    return nx.unique(nx.flatten(res), 'templateUuid');
  }

  @computed get templatesIds() {
    return this.templates.map(item => item.templateUuid);
  }

  @computed get businesses() {
    const res = this.selected.map(item => item.current);
    return nx.unique(res, 'uuid');
  }

  @computed get count() {
    return this.selected.length;
  }

  @computed get checkedTemplateIds() {
    return this.checked.filter(item => this.templatesIds.includes(item));
  }

  @computed get cartList() {
    const items = this.selected;
    if (items.length === 0) return [];
    const res = nx.groupBy(items, 'current.uuid', (_, item) => item.content);
    const tree = [];

    nx.forIn(res, (key, value) => {
      const target = nx.groupBy(value, 'template.templateUuid');
      const item = this.businesses.find(item => item.uuid === key);
      tree.push({ value: key, label: item.cnName, children: this.obj2list(target) });
    });
    return tree;
  }

  @computed get checkedContentUuids() {
    const checkedIds = this.checkedTemplateIds;
    const res = checkedIds.map(item => {
      const target = this.selected.filter(sItem => {
        return sItem.content.template.templateUuid === item;
      });
      return target.map(item => item.content.contentUuid);
    });
    return nx.flatten(res);
  }

  @computed get checkedSourceContents() {
    const checkedIds = this.checkedTemplateIds;
    const res = checkedIds.map(item => {
      const target = this.selected.filter(sItem => {
        return sItem.content.template.templateUuid === item;
      });
      return target.map(item => ({
        contentUuid: item.content.contentUuid,
        businessContentUuid: item.content.businessContentUuid,
      }));
    });
    return nx.flatten(res).filter(item => item.contentUuid && item.businessContentUuid);
  }

  @action
  empty() {
    this.checked.length = 0;
    this.selected.length = 0;
  }

  @action
  remove(inValue) {
    const value = Array.isArray(inValue) ? inValue : [inValue];
    nx.remove(this.checked, value);
    if (this.checkedTemplateIds.length === 0) {
      this.checked.length = 0;
    }
    nx.remove(this.selected, (_, item) => {
      return value.includes(item.content.template.templateUuid);
    });
  }

  @action
  removeChecked() {
    const checked = this.checked.slice();
    this.remove(checked);
  }

  includes(inContentUuid) {
    const ids = this.selected.map(item => item.content.contentUuid);
    return ids.includes(inContentUuid);
  }

  private obj2list(inObj) {
    const target = [];
    nx.forIn(inObj, (key, value) => {
      const item = this.templates.find(item => item.templateUuid === key);
      target.push({ value: key, label: item.templateName, children: value });
    });
    return target;
  }
}
